var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TechTalent',{scopedSlots:_vm._u([{key:"main",fn:function(){return [_c('router-view',{attrs:{"profileData":_vm.profileData},on:{"on-success":_vm.refreshData}})]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }